import * as React from 'react';
import RatingBox from './RatingBox';
import BREAK_POINTS from '../styling/media-queries';
import styled from 'styled-components';
import { LeftContentContainerStyles } from '../styling/styles';
import { Heading2, Subtitle, BodyText } from './Typography';
import getPartnerAsset, { DynamicAssetsKeys } from '../assets';

const fourPointFiveStars = require('./resources/stars-four-point-five.svg');
const fourPointSevenFiveStars = require('./resources/stars-four-point-seven-five.svg');
const fiveGreenStars = require('./resources/stars-trustpilot-five.svg');

const TestimonialContainer = styled.div`
  width: 100%;
  background: #fff;
  color: #1b1b1b;
  font-size: 18px;

  padding-top: 80px;
  padding-bottom: 80px;

  @media ${BREAK_POINTS.desktop} {
    font-size: 20px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const TestimonialContentContainer = styled.div`
  display: flex;
  flex: 5;

  justify-content: center;
  text-align: center;

  @media ${BREAK_POINTS.desktop} {
    justify-content: flex-start;
    text-align: left;
  }
`;

const TestimonialRatingsContainer = styled.div`
  display: flex;
  flex: 4;
  justify-content: flex-end;
  align-self: center;
`;

const TestimonialContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 460px;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 40px;

  @media ${BREAK_POINTS.desktop} {
    width: initial;
    padding: initial;
    margin: initial;
  }
`;

const TestimonialSubHeading = styled(Subtitle)`
  margin-bottom: 30px;
  font-weight: 600;
`;

const TestimonialDetails = styled(BodyText)``;

const RatingsContent = styled.div`
  display: inline-block;
  vertical-align: top;

  @media ${BREAK_POINTS.desktop} {
    margin-top: -45px;
  }
`;

const RatingsGroup = styled.div`
  display: flex;
  flex-direction: column;

  @media ${BREAK_POINTS.mobileBig} {
    flex-direction: row;
  }
`;

interface Rating {
  ratingSource: string;
  starsImage: string;
  ratingText: string;
  numReviews: number;
  linkAddress?: string;
}

// using multidimensional array to represent rating groups
const ratings: Rating[][] = [
  [
    {
      ratingSource: 'OUR CUSTOMERS RATE US',
      starsImage: fourPointSevenFiveStars,
      ratingText: '4.8 STARS',
      numReviews: 13000000,
      linkAddress: 'https://www.asurion.com/about/reviews-and-ratings/',
    },
    {
      ratingSource: 'TRUSTPILOT',
      starsImage: fiveGreenStars,
      ratingText: 'TRUSTSCORE 9.4',
      numReviews: 27000,
      linkAddress: 'https://www.trustpilot.com/review/www.asurion.com',
    },
  ],
  [
    {
      ratingSource: 'CONSUMER AFFAIRS',
      starsImage: fourPointFiveStars,
      ratingText: '4.5 STARS',
      numReviews: 4600,
      linkAddress: 'https://www.consumeraffairs.com/cell_phones/asurion.html',
    },
    {
      ratingSource: 'AMAZON',
      starsImage: fourPointFiveStars,
      ratingText: '4.6 STARS',
      numReviews: 190000,
      linkAddress:
        'https://www.amazon.com/sp?_encoding=UTF8&asin=&isAmazonFulfilled=&isCBA=&marketplaceID=ATVPDKIKX0DER&orderID=&seller=AF3DJOY0ZHFVY&tab=&vasStoreID',
    },
  ],
];

const TestimonialBox = styled.div`
  display: flex;
  max-width: 1440px;
  flex-direction: column;
  width: 100%;

  @media ${BREAK_POINTS.desktop} {
    flex-direction: row;
    padding-right: 50px;
    padding-left: 50px;
  }
`;

const testimonialTitle: string = getPartnerAsset(DynamicAssetsKeys.testimonialTitle);
const testimonialSubtitle: string = getPartnerAsset(DynamicAssetsKeys.testimonialSubtitle);
const testimonialBody: JSX.Element = getPartnerAsset(DynamicAssetsKeys.testimonialBody);
const TestimonialTitle: React.FC<any> = getPartnerAsset(DynamicAssetsKeys.testimonialTitleComponent);

const TestimonialSection: React.SFC<any> = (props) => {
  return (
    <TestimonialContainer>
      <TestimonialBox>
        <TestimonialContentContainer>
          <TestimonialContent>
            <TestimonialTitle>{testimonialTitle}</TestimonialTitle>
            <TestimonialSubHeading>{testimonialSubtitle}</TestimonialSubHeading>
            <TestimonialDetails>{testimonialBody}</TestimonialDetails>
          </TestimonialContent>
        </TestimonialContentContainer>

        <TestimonialRatingsContainer>
          <RatingsContent>
            {ratings.map((ratingGroup: Rating[], groupIndex: number) => {
              return (
                <RatingsGroup key={groupIndex}>
                  {ratingGroup.map((rating: Rating, ratingIndex: number) => {
                    return (
                      <RatingBox
                        key={ratingIndex}
                        ratingSource={rating.ratingSource}
                        starsImage={rating.starsImage}
                        ratingText={rating.ratingText}
                        numReviews={rating.numReviews}
                        linkAddress={rating.linkAddress}
                      />
                    );
                  })}
                </RatingsGroup>
              );
            })}
          </RatingsContent>
        </TestimonialRatingsContainer>
      </TestimonialBox>
    </TestimonialContainer>
  );
};

export default TestimonialSection;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/TestimonialSection.tsx